var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvChargingAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#D0E0E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9302 17.75L15.458 15H11.7913L13.3191 12.25M24.1663 15.9167V14.0833M10.233 20.5H17.0163C18.5565 20.5 19.3266 20.5 19.9148 20.2003C20.4323 19.9366 20.853 19.5159 21.1166 18.9985C21.4163 18.4102 21.4163 17.6401 21.4163 16.1V13.9C21.4163 12.3599 21.4163 11.5898 21.1166 11.0015C20.853 10.4841 20.4323 10.0634 19.9148 9.79973C19.3266 9.5 18.5565 9.5 17.0163 9.5H10.233C8.69286 9.5 7.92279 9.5 7.33453 9.79973C6.81709 10.0634 6.39639 10.4841 6.13274 11.0015C5.83301 11.5898 5.83301 12.3599 5.83301 13.9V16.1C5.83301 17.6401 5.83301 18.4102 6.13274 18.9985C6.39639 19.5159 6.81709 19.9366 7.33453 20.2003C7.92279 20.5 8.69286 20.5 10.233 20.5Z",
    stroke: "#45748C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvChargingAlert);
export default __webpack_public_path__ + "static/media/evChargingAlert.01c519a384e3b1ca8c5478d7f9d216ab.svg";
export { ForwardRef as ReactComponent };